import React from 'react';
import styles from './TrustSignals.module.scss';
import { Link } from '../../atoms/link/Link';
import clsx from 'clsx';
import { useMedia } from 'react-use';

export interface Media {
  file: string;
}

export interface Signal {
  text: string;
  desktopIcon?: { media: Media };
  mobileIcon?: { media: Media };
  reference?: string;
}

export interface TrustSignalsProps {
  signals: Signal[];
}

const TrustSignals: React.FC<TrustSignalsProps> = ({ signals }) => {
  const isMobile = useMedia('(max-width: 680px)', false);

  const renderContent = (signal: Signal) => {
    return (
      <>
        {(signal.desktopIcon?.media || signal.mobileIcon?.media) && (
          <img
            src={
              isMobile && signal.mobileIcon?.media?.file
                ? signal.mobileIcon?.media?.file
                : signal.desktopIcon?.media?.file
            }
            alt=""
          />
        )}
        <span className={styles.itemText}>{signal.text}</span>
      </>
    );
  };
  return (
    <div className={styles.container}>
      {signals.map((signal, key) => {
        if (signal.reference) {
          return (
            <Link key={key} link={{ reference: signal.reference }} className={clsx(styles.item, styles.itemLink)}>
              {renderContent(signal)}
            </Link>
          );
        }
        return (
          <div key={key} className={styles.item}>
            {renderContent(signal)}
          </div>
        );
      })}
    </div>
  );
};

export default TrustSignals;
